import { render, staticRenderFns } from "./intellect-push.vue?vue&type=template&id=146e7520&scoped=true"
import script from "./intellect-push.vue?vue&type=script&lang=js"
export * from "./intellect-push.vue?vue&type=script&lang=js"
import style0 from "./intellect-push.vue?vue&type=style&index=0&id=146e7520&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e7520",
  null
  
)

export default component.exports